import type { Dispatch } from 'react-redux';
import { apiRoot } from 'src/shared/app/base/api/apiRoot';

export const invalidateTags = (
  type: typeof TAG_TYPE | Array<{ type: typeof TAG_TYPE, id: number | string }>,
  id?: number | 'LIST',
) => {
  const invalidate = apiRoot.util.invalidateTags;

  return (dispatch: Dispatch) => {
    if (Array.isArray(type)) {
      return dispatch(invalidate(type));
    }

    if (id) {
      return dispatch(
        invalidate([
          {
            type,
            id,
          },
        ]),
      );
    }

    return dispatch(invalidate([type]));
  };
};
